import { useForm, UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';
import * as yup from 'yup';
import { IdentityProvidersMessages } from '../../IdentityProviders.messages';
import { yupResolver } from '@hookform/resolvers/yup';
import { externalIdpLogoutConfigSchema } from 'pages/IdentityProviders/schema/identityProviderSchema';

type UseUpdateSamlProviderForm = () => UseFormReturn;

export const useUpdateSamlProviderForm: UseUpdateSamlProviderForm = () => {
  const intl = useIntl();
  const updateIdentityProviderValidationSchema = yup.object().shape({
    name: yup.string().required(intl.formatMessage(IdentityProvidersMessages.nameRequiredError)),
    entityId: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.clientIdRequiredError)),
    rpEntityId: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.rpEntityIdRequiredError)),
    ssoUrl: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.ssoUrlRequiredError))
      .url(intl.formatMessage(IdentityProvidersMessages.issuerUrlValidationError)),
    externalIdField: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.externalIdRequiredError))
      .oneOf(['Uid', 'Email', 'PhoneNumber']),
    certificates: yup
      .array()
      .required('At least one certificate is required')
      .min(1, 'At least one certificate required')
      .of(
        yup.object().shape({
          value: yup
            .string()
            .test(
              'valid-cert',
              'Must start with "-----BEGIN CERTIFICATE-----", and end with "-----END CERTIFICATE-----".',
              (val) => {
                if (val) {
                  return (
                    val?.startsWith('-----BEGIN CERTIFICATE-----') &&
                    val?.endsWith('-----END CERTIFICATE-----')
                  );
                }
                return false;
              },
            ),
        }),
      ),
    externalIdpLogoutConfig: externalIdpLogoutConfigSchema,
    prompt: yup
      .string()
      .required(intl.formatMessage(IdentityProvidersMessages.promptRequiredError))
      .matches(
        /(none|login|consent|select_account)/,
        'Prompt must equal none, login, consent or select_account',
      ),
  });
  return useForm({
    resolver: yupResolver(updateIdentityProviderValidationSchema),
    mode: 'onChange',
  });
};
